export default __webpack_public_path__ + "static/media/ScratchJr.4a3df205.webp";